import React from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import './HorizontalStepper.css';

export default function HorizontalStepper(props) {
  const [activeStep, setActiveStep] = React.useState(0);
  const { steps, handleClick } = props;

  const handleStep = step => () => {
    setActiveStep(step);
    handleClick(step);
  };
  return (
    <div
      style={{ width: '100%', justifyContent: 'flex-start', color: 'white' }}
    >
      <Stepper alternativeLabel nonLinear activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          return (
            <Step key={label} {...stepProps}>
              <StepButton onClick={handleStep(index)}>
                <p style={{ color: 'white' }}>{label}</p>
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}
